export const SVG_PARAMS = {
  blockSize: 8,
  pColumns: 64,
  tooltipW: 650
};
